import { render, staticRenderFns } from "./VerifyOTP.vue?vue&type=template&id=0f19344b&scoped=true&"
import script from "./VerifyOTP.vue?vue&type=script&lang=ts&"
export * from "./VerifyOTP.vue?vue&type=script&lang=ts&"
import style0 from "./VerifyOTP.vue?vue&type=style&index=0&id=0f19344b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f19344b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VOtpInput } from 'vuetify/lib/components/VOtpInput';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VOtpInput,VOverlay,VProgressCircular,VRow,VSnackbar})
